module.exports = __webpack_public_path__ + "img/yuangong.60c0f2ed.svg";